import { RootState } from 'redux/reducers'
import { createSelector } from 'reselect'

export const selectTotalMultiSelectedSize = createSelector(
  (state: RootState) => state.folders.selectedSubfolders,
  (state: RootState) => state.folders.selectedDecks,
  (selectedSubfolders = {}, selectedDecks = {}) => {
    return [...Object.values(selectedSubfolders), ...Object.values(selectedDecks)].filter(selected => selected).length
  },
)

export const selectIsFolderMultiSelected = (id: string | number) =>
  createSelector(
    (state: RootState) => state.folders.selectedSubfolders,
    (selectedSubfolders = {}) => !!selectedSubfolders[Number(id)],
  )

export const selectIsDeckMultiSelected = (id: string | number) =>
  createSelector(
    (state: RootState) => state.folders.selectedDecks,
    (selectedDecks = {}) => selectedDecks[Number(id)],
  )
